import { Group } from "../types/groups";
import { useMemoryFilteredData } from "@coworker/apprestructured/src/shared/filters/utils/apply/useMemoryFilteredData";
import { useSortSelectGroupFilter } from "../filters/useSortSelectGroupFilter";
import preferences from "@coworker/enums/profilePreferences";
import { useUserPreferenceStoreFilterValues } from "@coworker/apprestructured/src/shared/filters/utils/store/useUserPreferenceStoreFilterValues";
import { FilterValue } from "@coworker/apprestructured/src/shared/filters/types/filter";

export function useGroupsFilters() {
  const { filterValues, setFilterValues } = useUserPreferenceStoreFilterValues(
    preferences.MEDIA_FILTERS_GROUPS
  );

  const useFiltersFactory = (values: FilterValue[]) => {
    const sortFilter = useSortSelectGroupFilter(values);
    return [sortFilter.filter];
  };

  function useFilteredGroupData(groups: Group[] | undefined) {
    const sortFilter = useSortSelectGroupFilter(filterValues);
    return useMemoryFilteredData<Group>(groups, [sortFilter], filterValues);
  }

  return {
    useFiltersFactory,
    filterValues,
    setFilterValues,
    useFilteredGroupData,
  };
}
